import AxiosAPI from '../../utils/AxiosAPI';

// Create New Admin
export const ApiCreateNewAdmin = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/admin`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Create New Admin
export const ApiAdminInfoUpdate = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/admin/${id}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export const ApiChangeStatus = (formData, customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/status`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const ApiAdminSearch = (q) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/admin/search`, { q })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });

export const ApiChangeRole = (formData, customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/role`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const ApiDisable2fa = (customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/disable-2fa`)
            .put()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const ApiUpdateInfo = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${formData.Id}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// load admins info
export const ApiLoadAdminsData = (params) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/admin`, {
                q: params.q,
                status: params.status,
                orderby: params['order-by'],
                sort: params.sort,
                cpp: 12
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Get Customer Details by Id
export const ApiAdminInfoData = (id) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/admin/${id}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Change Product Logo
export const ApiChangeProfileLogo = (id, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`api/customers/${id}/change-profile-image `)
            .put(formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// add permissions
export const ApiAddPermission = (id, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/user-permission/${id}/add`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// remove permissions
export const ApiRemovePermission = (id, key) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/user-permission/${id}/remove/${key}`)
            .delete()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
